import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService} from 'src/app/services/toast.service'
import { ConnectionService } from 'src/app/services/connection.service';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { LoaderService } from 'src/app/services/loader.service';
@Component({
  selector: 'app-settings',
  templateUrl: './settings.page.html',
  styleUrls: ['./settings.page.scss'],
})
export class SettingsPage implements OnInit {
  
  userObj:any;
  access_token:any;
  showchangepassworddiv: boolean;
  Changepasswordform: FormGroup;
  passwordtoogleicon: any = 'eye';
  showpassword: boolean = false;
  adminAccessGiven: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private strg: StorageService,
    private toast: ToastService,
    private apiService: ConnectionService,
    private fb: FormBuilder,
    private alertCtrl: AlertController,
    private _loader: LoaderService
  ) {   
  }
  get Password() {
    return this.Changepasswordform.get('Password');
  }
  get conformpassword() {
    return this.Changepasswordform.get('Conformpassword');
  }
  
  ionViewDidEnter(){
    console.log("this is ion did enter")
    this.strg.getStoreData("userObj").then(res=>{
      this.userObj = res;
      console.log('rytiuer', this.userObj, res.isAdvisorAccessible);
      this.adminAccessGiven = res.isAdvisorAccessible;
    });
  }

  ngOnInit() {
    // this.strg.getStoreData("userObj").then(res=>{
    //   this.userObj = res;
    //   console.log('rytiuer', this.userObj);
    //   this.adminAccessGiven = this.userObj.user.advisorAccessible;
    // });
    
    this.Changepasswordform = this.fb.group({
      oldpassword: ['', [
        Validators.pattern('^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$'),
        Validators.minLength(6),
        Validators.maxLength(25)
      ]
      ],
      newpassword: ['', [
        //Validators.pattern('^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$'),
        //Validators.minLength(6),
        Validators.maxLength(25)
      ]
      ],
      Conformpassword: ['', [
       // Validators.pattern('^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$'),
        //Validators.minLength(6),
        Validators.maxLength(25)
      ]
      ],
    });  
  }

  logoutClicked(){
    this.authService.revokeAuthTokenOnLogout(this.access_token, this.userObj.id).subscribe(ress => {
      console.log("token revoked!")
      this.strg.removeStoreData("userObj").then(res => {
        this.strg.removeStoreData("insAccessToken").then(res => {
          this.strg.removeStoreData("insRefreshToken").then(res => {
            this.authService.authState.next(false);
            this.router.navigate(['/login']);
            // this.router.navigate(['login'], { queryParams: { returnUrl: this.router.url }});
            // window.open("https://www.mypolicyjunction.com/", "_self");
          });
        });
      });
    });
  }

  togglepassword() {
    this.showpassword = !this.showpassword;
    if (this.passwordtoogleicon == 'eye') {
      this.passwordtoogleicon = "eye-off";
    }
    else {
      this.passwordtoogleicon = "eye";
    } 
  }

  changepasswordtoggle(){
    this.showchangepassworddiv = true;
  }

  changepassword(){   
    if (this.Changepasswordform.get('newpassword').value === this.Changepasswordform.get('Conformpassword').value) {
      if (/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(this.Changepasswordform.get('Conformpassword').value)) {
        let userDetails = {         
          "oldPassword": this.Changepasswordform.get('oldpassword').value,
          "newPassword": this.Changepasswordform.get('newpassword').value
        };
        console.log(userDetails,'userdetails');       
        this.apiService.changePassword(userDetails).subscribe(res=>{         
          if (res) {
            if (res.status == "OK") {
              this.showchangepassworddiv = false;
              this.showpassword = false;
              this.Changepasswordform.reset();
              this.passwordtoogleicon = 'eye';
              console.log("password Changed");              
              this.toast.showToast("Password Changed Succesfully. Please Re-Login");
              this.logoutClicked()
              //this.router.navigate(["/login"]);
            } else {
              this.toast.showToast("Something went wrong! Please try again later");
            }
          }
        }, err => {
          console.log(err)
          this.toast.showToast(err.error.message);
          this.showchangepassworddiv = false;
          this.showpassword = false;
          this.Changepasswordform.reset();
          this.passwordtoogleicon = 'eye';
        })
      } 
      else {       
      this.toast.showToast("Password must contain both capital, small numbers, special character and should be of minimum 8 characters", 6000);
      }
    } else {   
      this.toast.showToast("Password Mismatch. Please try again");
    }
  }
  cancelback(){
    this.showchangepassworddiv = false;
  }
  
  async helpandsupport(){
    // this.router.navigate(['/home/help'])
    const alert = await this.alertCtrl.create({
      cssClass: "alert-css",
      header: "Support",
      message: `Your Support ID: ${this.userObj.id} <br><br> Please write to the email: support@mypolicyjunction.com. Please mention your support id in the email subject.`,
      buttons: [
        {
          text: "Ok",
          role: 'cancel',
          handler: (blah) => {
            console.log("no");
          } 
        },
      ]
    });
    alert.present();
  }

  async adminaccess(){
    const alert = await this.alertCtrl.create({
      cssClass: "alert-css",
      header: this.adminAccessGiven ? "Revoke Admin Access" : "Provide Admin Access",
      message: this.adminAccessGiven ? "Do you want to revoke admin access?" : "Do you want to provide admin access?",
      buttons: [
        {
          text: "Cancel",
          role: 'cancel',
          handler: (blah) => {
            console.log("no");
          } 
        },
        {
          text: "Yes",
          handler: () => {
            console.log("yes");
            this.setAdminAccess();
          }
        }
      ]
    });
    alert.present();
  }

  setAdminAccess(){
    let data: any;
    if(this.adminAccessGiven){
      data = false;
    } else {
      data = true;
    }
    console.log("ffffff", data, this.adminAccessGiven);
    this._loader.showLoader();
    this.apiService.Adminaccess(data).subscribe(res=>{
      console.log(res);
      if(res.status === "OK"){
        if(data){
          this.toast.showToast("Admin acesss given succesfully");
        } else {
          this.toast.showToast("Admin acesss revoked succesfully");
        }
        this.authService.getUserDetails().subscribe(res => {
          console.log("get user details", res);
          if(res.status === "OK"){
            this.strg.setStoreData("userObj",res.data).then(res => {
              this._loader.hideLoader();
              console.log('newobject', res);
              this.ionViewDidEnter();
            });
          }
        });
      }
    },err=>{
      console.log(err);
      this.toast.showToast(err);
    })
  }

}
